import { useMe } from 'utils/api/useMe';
import { Role } from 'generated/graphql';

export const useMeRole = (roles: Role[]) => {
  const me = useMe();
  if (!me) return false;
  return roles.includes(me.role);
};
